import { FC, ReactNode } from 'react';
import { styled } from '@mui/material';
import { ControlTitle } from './ControlTitle';

interface ControlSectionProps {
  title: string;
  children: ReactNode;
  titleAction?: ReactNode; // Optional action button next to the title
  warning?: boolean;
  warningAction?: ReactNode; // Optional warning component next to the title
}

export const ControlSection: FC<ControlSectionProps> = ({
  title,
  children,
  titleAction,
  warning,
  warningAction,
}) => {
  return (
    <SectionContainer>
      <SectionHeader>
        <TitleContainer>
          <ControlTitle>{title}</ControlTitle>
          {warning && warningAction}
        </TitleContainer>
        {titleAction}
      </SectionHeader>
      <SectionContent>{children}</SectionContent>
    </SectionContainer>
  );
};

// Styled Components
const SectionContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5), // This is the unified spacing between title and content
}));

const SectionHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
});

const SectionContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

const TitleContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: 4,
  flexDirection: 'row',
});
